export function EraserIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.913 3.557a3 3 0 014.148.09l3.17 3.169a3 3 0 01-.095 4.333l-9.049 8.294c-.262.241-.557.427-.869.557H19a1 1 0 110 2H5a1 1 0 110-2h2.902a2.99 2.99 0 01-.963-.647L3.77 16.184a3 3 0 01.094-4.333l9.049-8.294zm-.447 11.91l-4.584-4.585-2.666 2.444a1 1 0 00-.032 1.444l3.17 3.169a1 1 0 001.382.03l2.73-2.503z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
